import type { Room } from "building-types/rooms/roomTypes";
import type { StaticRoom } from "building-types/rooms/staticRoomTypes";
import type { Table } from "common/data/table";

const defaultBedBathCounts = {
  bedroomCount: 0,
  bathroomCount: 0,
};

export default function getBedBathCount(rooms: Table<Room> | Table<StaticRoom>) {
  const counts = { ...defaultBedBathCounts };

  for (const id in rooms) {
    const room = rooms[id];

    counts.bathroomCount += room.attributes?.bathroomCount ?? 0;
    counts.bedroomCount += room.attributes?.bedroomCount ?? 0;
  }

  return counts;
}
